<template>
  <div
    class="p-20 border-r16 shadow-1 bg-white mt-20 StartJD"
    style="height:800px;"
  >
    <!-- 初创企业总数 -->
    <p class="data-title ">项目所在阶段</p>
    <div v-for="(value, index) in msg" :key="index">
      <div class="add-P">
        {{ value.name }}
        <span>{{ value.value }}%</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StartJD",
  // props: { msg: Array },
  data() {
    return {
      msg: [
        {
          value: 8.02,
          name: "种子轮",
        },
        {
          value: 17.74,
          name: "天使轮",
        },
        {
          value: 9.21,
          name: "Pre-A轮",
        },
        {
          value: 17.35,
          name: "A轮",
        },
        {
          value: 3.29,
          name: "A+轮",
        },
        {
          value: 0.36,
          name: "Pre-B轮",
        },
        {
          value: 6.99,
          name: "B轮",
        },
        {
          value: 1.12,
          name: "B+轮",
        },
        {
          value: 2.31,
          name: "C轮",
        },
        {
          value: 0.52,
          name: "C+轮",
        },
        {
          value: 0.75,
          name: "D轮",
        },
        {
          value: 0.15,
          name: "Pre-IPO轮",
        },
        {
          value: 1.11,
          name: "IPO",
        },
        {
          value: 0.13,
          name: "E轮",
        },
        {
          value: 0.08,
          name: "E+轮",
        },
        {
          value: 3,
          name: "战略轮",
        },
        {
          value: 0.46,
          name: "并购",
        },
        {
          value: 17.24,
          name: "未披露",
        },
        {
          value: 0.05,
          name: "终止业务",
        },
      ],
    };
  },
  watch() {
    // console.log("初创企业总数",this.msg);
  },
  methods: {},
};
</script>

<style scoped>
.StartJD {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 20px;
  margin-top: 20px;
}
.data-title {
  font-size: 24px;
  color: #333;
  font-weight: 600;
  margin-left: 0;
  padding-top: 16px;
}
.add-P {
  font-weight: bold;
  font-size: 18px;
  margin-top: 14px;
}
.add-P span {
  float: right;
  font-size: 16px;
  font-weight: normal;
}
</style>
